module.exports = __webpack_public_path__ + "static/media/snowplow.70441ba8.svg";